import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import docAid from "../../assets/doc-aid.png";

// Helper to get all users (default + stored)
const getAllUsers = () => {
  const defaultUsers = [
    { email: "admin@gmail.com", password: "123456", role: "admin" },
    { email: "doctor@gmail.com", password: "123456", role: "doctor" },
    { email: "patient@gmail.com", password: "123456", role: "patient" },
  ];
  const stored = JSON.parse(localStorage.getItem("users")) || [];
  return [...defaultUsers, ...stored];
};

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (!email) {
      setError("Please enter email");
      setLoading(false);
      return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      setError("Please enter valid email");
      setLoading(false);
      return;
    }

    // Check if email already registered
    const users = getAllUsers();
    if (users.some((u) => u.email === email)) {
      toast.error("Email already registered. Please login.");
      setLoading(false);
      return;
    }

    // Generate OTP
    const otp = Math.floor(1000 + Math.random() * 9000);

    // Store OTP and email in localStorage (key: userOTP)
    localStorage.setItem(
      "userOTP",
      JSON.stringify({
        email: email,
        otp: otp,
        timestamp: Date.now(),
      })
    );

    toast.success(`OTP sent to ${email} (Demo: ${otp})`);
    setLoading(false);
    navigate("/validateOTP");
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="max-w-5xl w-full bg-white shadow-xl rounded-2xl overflow-hidden flex flex-col lg:flex-row">
        {/* Image Section */}
        <div className="lg:w-1/2 flex justify-center items-center p-8">
          <img src={docAid} alt="doctor" className="w-[300px] lg:w-[420px]" />
        </div>

        {/* Form Section */}
        <div
          className="lg:w-1/2 p-10 flex items-center"
          style={{ backgroundColor: "rgb(237,231,242)" }}
        >
          <form onSubmit={handleSubmit} className="w-full">
            <h1 className="text-3xl font-bold text-center mb-3">
              Create Account
            </h1>
            <p className="text-center text-gray-600 mb-8">
              Verify your email address
            </p>

            <input
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError("");
              }}
              placeholder="Enter Email"
              className="w-full px-6 py-4 rounded-xl bg-white border border-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500"
            />

            {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className="mt-6 w-full py-4 rounded-xl text-white font-semibold transition hover:scale-105 disabled:opacity-50"
              style={{ backgroundColor: "rgb(7,160,165)" }}
            >
              {loading ? "Sending OTP..." : "Sign Up"}
            </button>

            <p className="mt-6 text-center text-gray-800">
              Already have an Account? &nbsp;
              <Link
                to="/"
                className="font-semibold text-lg"
                style={{ color: "rgb(7,160,165)" }}
              >
                Login
              </Link>
            </p>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default VerifyEmail;